var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useRecoilState } from "recoil";
import { useRequest } from "../../hooks/useRequest";
import { twilioCallSetupAtom } from "../store";
export var useTwilio = function () {
    var request = useRequest();
    var _a = useRecoilState(twilioCallSetupAtom), twilioCallSetupData = _a[0], serTwilioCallSetupData = _a[1];
    var getTwilioCallSetupData = function (flowId) {
        request
            .get("/twilio/accessToken/" + flowId)
            .then(function (_a) {
            var data = _a.data;
            serTwilioCallSetupData(data);
        })
            .catch(console.log);
    };
    var getTwilioWebhookUrl = function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.get("/twilio/webhooks/" + flowId)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.webhookUrl];
            }
        });
    }); };
    var createSipDomain = function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post("/twilio/sip/domains/" + flowId)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); };
    var regenerateSipPassword = function (sipConfigId) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.patch("/twilio/sip/domains/".concat(sipConfigId, "/password"))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.newPassword];
            }
        });
    }); };
    var listOwnedPhoneNumbers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.get("/twilio/numbers")];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data]; // This is from your local DB now
            }
        });
    }); };
    var purchasePhoneNumber = function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post("/twilio/numbers", { phoneNumber: phoneNumber })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); };
    var deletePhoneNumber = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.delete("/twilio/numbers/".concat(id))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); };
    var listAvailablePhoneNumbers = function (countryCode, limit) {
        if (countryCode === void 0) { countryCode = "US"; }
        if (limit === void 0) { limit = 20; }
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, request.get("/twilio/numbers/available?countryCode=".concat(countryCode, "&limit=").concat(limit))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return {
        listOwnedPhoneNumbers: listOwnedPhoneNumbers,
        purchasePhoneNumber: purchasePhoneNumber,
        deletePhoneNumber: deletePhoneNumber,
        listAvailablePhoneNumbers: listAvailablePhoneNumbers,
        twilioCallSetupData: twilioCallSetupData,
        getTwilioCallSetupData: getTwilioCallSetupData,
        getTwilioWebhookUrl: getTwilioWebhookUrl,
        createSipDomain: createSipDomain,
        regenerateSipPassword: regenerateSipPassword,
    };
};
